import {useGetSample} from '../context/useSample'

function UserDetail() {
  const {isLoading} = useGetSample()

  console.log('isLoading', isLoading)

  return (
    <div className='d-flex flex-column flex-lg-row'>
      <div className='flex-column flex-lg-row-auto w-lg-250px w-xl-350px mb-10'>
        <div className='card mb-5 mb-xl-8'>
          <div className='card-body'>
            <div className='d-flex flex-center flex-column py-5'>
              <a href='#' className='fs-3 text-gray-800 text-hover-primary fw-bold mb-3'>
                John Doe
              </a>

              <div className='mb-9'>
                <div className='badge badge-lg badge-light-primary d-inline'>Administrator</div>
              </div>
            </div>

            <div className='d-flex flex-stack fs-4 py-3'>
              <div
                className='fw-bold rotate collapsible'
                data-bs-toggle='collapse'
                role='button'
                aria-expanded='false'
                aria-controls='kt_user_view_details'
              >
                Details
                <span className='ms-2 rotate-180'>
                  <i className='ki-outline ki-down fs-3'></i>
                </span>
              </div>
            </div>

            <div className='separator'></div>

            <div id='kt_user_view_details' className='collapse show'>
              <div className='pb-5 fs-6'>
                <div className='fw-bold mt-5'>Account ID</div>
                <div className='text-gray-600'>ID-45453423</div>

                <div className='fw-bold mt-5'>Address</div>
                <div className='text-gray-600'>101 Collin Street, US</div>

                <div className='fw-bold mt-5'>Language</div>
                <div className='text-gray-600'>English</div>

                <div className='fw-bold mt-5'>Last Login</div>
                <div className='text-gray-600'>09/24/2023 10:45 PM</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='flex-lg-row-fluid ms-lg-15'>
        <div className='card pt-4 mb-6 mb-xl-9'>
          <div className='card-header border-0'>
            <div className='card-title'>
              <h2>Profile</h2>
            </div>
          </div>

          <div className='card-body pt-0 pb-5'>
            <div className='table-responsive'>
              <table
                className='table align-middle table-row-dashed gy-5'
                id='kt_table_users_login_session'
              >
                <tbody className='fs-6 fw-semibold text-gray-600'>
                  <tr>
                    <td>Email</td>
                    <td>doe@vasco.life</td>
                    <td className='text-end'>
                      <button
                        type='button'
                        className='btn btn-icon btn-active-light-primary w-30px h-30px ms-auto'
                        data-bs-toggle='modal'
                        data-bs-target='#kt_modal_update_email'
                      >
                        <i className='ki-outline ki-pencil fs-3'></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>Password</td>
                    <td>******</td>
                    <td className='text-end'>
                      <button
                        type='button'
                        className='btn btn-icon btn-active-light-primary w-30px h-30px ms-auto'
                        data-bs-toggle='modal'
                        data-bs-target='#kt_modal_update_password'
                      >
                        <i className='ki-outline ki-pencil fs-3'></i>
                      </button>
                    </td>
                  </tr>
                  <tr>
                    <td>Role</td>
                    <td>Administrator</td>
                    <td className='text-end'>
                      <button
                        type='button'
                        className='btn btn-icon btn-active-light-primary w-30px h-30px ms-auto'
                        data-bs-toggle='modal'
                        data-bs-target='#kt_modal_update_role'
                      >
                        <i className='ki-outline ki-pencil fs-3'></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className='card pt-4 mb-6 mb-xl-9'>
          <div className='card-header border-0'>
            <div className='card-title'>
              <h2>Login Sessions</h2>
            </div>
          </div>

          <div className='card-body pt-0 pb-5'>
            <div className='table-responsive'>
              <table
                className='table align-middle table-row-dashed gy-5'
                id='kt_table_users_login_session'
              >
                <thead className='border-bottom border-gray-200 fw-bold'>
                  <tr className='text-start gs-0'>
                    <th className='min-w-100px'>Location</th>
                    <th>Device</th>
                    <th>IP Address</th>
                    <th className='min-w-125px'>Time</th>
                    <th className='min-w-70px'>Actions</th>
                  </tr>
                </thead>
                <tbody className='fs-6 fw-semibold text-gray-600'>
                  <tr>
                    <td>US</td>
                    <td>Chome - Windows</td>
                    <td>207.20.10.286</td>
                    <td>23 seconds ago</td>
                    <td>Current session</td>
                  </tr>
                  <tr>
                    <td>US</td>
                    <td>Safari - iOS</td>
                    <td>207.45.11.20</td>
                    <td>3 days ago</td>
                    <td>Sign out</td>
                  </tr>
                  <tr>
                    <td>US</td>
                    <td>Chrome - Windows</td>
                    <td>207.16.20.186</td>
                    <td>last week</td>
                    <td>Expired</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div className='card pt-4 mb-6 mb-xl-9'>
          <div className='card-header border-0'>
            <div className='card-title'>
              <h2>Logs</h2>
            </div>

            <div className='card-toolbar'>
              <button type='button' className='btn btn-sm btn-light-primary'>
                <i className='ki-outline ki-cloud-download fs-3'></i>Download Report
              </button>
            </div>
          </div>

          <div className='card-body py-0'>
            <div className='table-responsive'>
              <table className='table align-middle table-row-dashed gy-5' id='kt_table_users_logs'>
                <tbody>
                  <tr>
                    <td className='min-w-70px'>
                      <div className='badge badge-light-success'>200 OK</div>
                    </td>
                    <td>POST /v1/invoices/in_7650_5900/payment</td>
                    <td className='pe-0 text-end min-w-200px'>22 Sep 2023, 11:30 am</td>
                  </tr>
                  <tr>
                    <td className='min-w-70px'>
                      <div className='badge badge-light-success'>200 OK</div>
                    </td>
                    <td>POST /v1/invoices/in_6943_8896/payment</td>
                    <td className='pe-0 text-end min-w-200px'>10 Nov 2023, 6:05 pm</td>
                  </tr>
                  <tr>
                    <td className='min-w-70px'>
                      <div className='badge badge-light-danger'>500 ERR</div>
                    </td>
                    <td>POST /v1/invoice/in_4712_1363/invalid</td>
                    <td className='pe-0 text-end min-w-200px'>15 Apr 2023, 6:05 pm</td>
                  </tr>
                  <tr>
                    <td className='min-w-70px'>
                      <div className='badge badge-light-warning'>404 WRN</div>
                    </td>
                    <td>POST /v1/customer/c_64b77d3f95388/not_found</td>
                    <td className='pe-0 text-end min-w-200px'>24 Jun 2023, 6:05 pm</td>
                  </tr>
                  <tr>
                    <td className='min-w-70px'>
                      <div className='badge badge-light-success'>200 OK</div>
                    </td>
                    <td>POST /v1/invoices/in_5124_2953/payment</td>
                    <td className='pe-0 text-end min-w-200px'>10 Nov 2023, 10:10 pm</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserDetail
